<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
                <el-breadcrumb-item>
                    <a href="javascript:void(0);" @click="$router.push('/medication')" class="aHref">专业用药</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item>药物详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="infoCon">

                <div v-if="details.thumbnailPath" :style="'backgroundImage: url('+details.thumbnailPath+')'" class=" newDrug img">
                    <span v-if="details.drugType === 1">新药</span>
                </div>

                <div v-else class="newDrug img" style="background-image:url('/static/default_imgs/drug.jpg')">
                    <span v-if="details.drugType === 1">新药</span>
                </div>

                <div class="rightDetail" v-if="!needLogin">
                    <div class="flex">
                        <h2>{{details.cnName}}</h2>
                        <span class="engName">{{details.enName}} </span>
                        <span v-if="attention!=='未登录'">
                            <el-switch
                                    @change="changeState"
                                    v-model="flag"
                                    :active-text="attention"
                                    inactive-text=" ">
                            </el-switch>
                        </span>
                    </div>
                    <div class="indicationsTit" v-if="details.briefDesc">
                        <span class="tit">简介</span>
                        <p style="white-space: pre-line">{{details.briefDesc}}</p>
                    </div>
                    <div class="indicationsTit" v-if="details.indications.length>0">
                        <span class="tit">适应症</span>
                        <p v-for="indication in details.indications" :key="indication.id">{{indication.cnName}}</p>
                    </div>
                    <div class="indicationsTit" v-if="details.dose">
                        <span class="tit">剂量</span>
                        <p style="white-space: pre-line">{{details.dose}}</p>
                    </div>
                    <div class="indicationsTit" v-if="details.blackBoxWarn">
                        <span class="tit">黑盒子警告</span>
                        <p style="white-space: pre-line">{{details.blackBoxWarn}}</p>
                    </div>
                    <div class="indicationsTit" v-if="details.taboo">
                        <span class="tit">禁忌症</span>
                        <p style="white-space: pre-line">{{details.taboo}}</p>
                    </div>
                    <div class="indicationsTit" v-if="details.sideEffect">
                        <span class="tit">常见副作用</span>
                        <p style="white-space: pre-line">{{details.sideEffect}}</p>
                    </div>
                    <div class="indicationsTit" v-if="details.principle">
                        <span class="tit">药物原理</span>
                        <p style="white-space: pre-line">{{details.principle}}</p>
                    </div>
                    <div class="indicationsTit" v-if="details.drugInteractions">
                        <span class="tit">药物相互作用</span>
                        <p style="white-space: pre-line">{{details.drugInteractions}}</p>
                    </div>
                    <div class="indicationsTit" v-if="details.pregnancyAttention">
                        <span class="tit">注意事项</span>
                        <p v-html="details.pregnancyAttention" style="white-space: pre-line">{{details.pregnancyAttention}}</p>
                    </div>
                </div>
                <div v-if="needLogin" style="width: 800px; text-align: center; margin-top: 50px;">
                    <span v-show="needLogin" @click="showLoginDialog" class="checkAll">登录/注册查看详细信息</span>
                </div>
            </div>
            <div class="heat">
                <span class="hearTit">药品关注热度榜</span>
                <div class="heatRight flex">
                    <div v-for="(obj ,ind) in drugs" :key="ind" v-show="ind<7" class="list" @click="toDetails(obj.id)">
                        <div :style="'backgroundImage: url('+obj.thumbnailPath+')'" class=" newDrug img">
                            <span v-if="obj.drugType">新药</span>
                        </div>
                        <p class="overFlow"><span :class="ind<3?'bg':''">{{ind+1}}</span>{{obj.cnName}}</p>
                    </div>
                </div>
            </div>
        </div>
        <loginDialog ref="loginDialog"></loginDialog>
    </div>
</template>

<script>
    import base from '@/api/common';
    import loginDialog from "../loginDialog";
    export default {
        name: "medicationDetail",
        data() {
            return {
                id: this.$route.query.id,
                details: {
                    indications: [],
                },
                drugs: [],
                flag: false,
                attention: '未关注',

                needLogin: false,
            }
        },
        inject: ['reload'],
        async mounted() {
            document.onmousedown = function (e) {
                if (e.button == 2) {
                    e.returnValue = false;
                }
            };
            document.addEventListener("copy", function (e) {
                //取消默认事件，才能修改复制的值
                e.preventDefault();
                //复制的内容
                let copyTxt = `${window.location.href}`;
                if (e.clipboardData) {
                    e.clipboardData.setData('text/plain', copyTxt);
                } else if (window.clipboardData) {
                    return window.clipboardData.setData("text", copyTxt);
                }
            });
            let user = await base.utils.getCurrent();
            let url;
            if (user != null) {
                this.getConcern();
                url = base.api.drug.details_auth;
            } else {
                url = base.api.drug.details;
                this.attention = '未登录';
            }
            /*
            try {
                this.$parent.$refs.headerRef.active = 4;
            } catch (e) {
                console.warn("active undefined");
            }
            */
            // load details
            if (this.id) {
                this.$ajax.get(url.replace("{id}", this.id)).then((res) => {
                    if (res.data.status === 'success') {
                        this.details = res.data.data;
                    }else if(res.data.status === 'needUserLogin'){
                        this.needLogin = true;
                    } else {
                        this.$router.back();
                    }
                })
            } else {
                this.$router.back();
            }

            // load drugs
            this.$ajax.get(base.api.drug.tops).then((res) => {
                if (res.data.status === 'success') {
                    this.drugs = res.data.list;
                }
            })


        },
        components: {loginDialog},
        methods: {
            toDetails(id) {
                location.href = 'medicationDetail?id=' + id;
            },
            showLoginDialog(){
                this.$refs.loginDialog.dialogVisible = true;
                this.$refs.loginDialog.reloadCode('vcode-user')
            },
            changeState() {
                // this.flag = !this.flag;
                if (this.flag === true) {
                    this.flag = true;
                    this.attention = "已关注";
                    this.addUserConcernMethod();
                } else if (this.flag === false) {
                    this.flag = false;
                    this.attention = "未关注";
                    this.deleteUserConcernMethod();
                }
            },
            getConcern() {
                let that = this;
                this.$ajax
                    .get(base.api.drug.concern.get.replace("{drugId}",this.id))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                          if (res.data.data === true) {
                            that.flag = true;
                            that.attention = "已关注";
                          } else {
                            that.flag = false;
                            that.attention = "未关注";
                          }
                        }
                    })
            },
            addUserConcernMethod() {
                let that = this;
                this.$ajax.post(base.api.drug.concern.add.replace("{drugId}",this.id))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                            that.$message.success("操作成功")
                        } else {
                          that.$message.error(res.data.message);
                        }
                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败');
                })
            },
            deleteUserConcernMethod() {
                let that = this;
                this.$ajax.delete(base.api.drug.concern.delete.replace("{drugId}",this.id))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                          that.$message.success('操作成功');
                        } else {
                          that.$message.error(res.data.message);
                        }
                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败');
                })
            },
        }
    }
</script>

<style scoped lang="scss">
@import '../../assets/css/medication.scss';
.checkAll {
    display: block;
    width: 233px;
    height: 40px;
    background: #567BFF;
    border-radius: 7px;
    line-height: 40px;
    margin: auto;
    font-size: 17px;
    color: #ffffff;
    cursor: pointer;
    text-align: center;
}
</style>